import React, { useEffect } from 'react';
import Navbar from '../../Components/Common/Navbar';
import Footer from '../../Components/Common/Footer';
import HeroSection from '../../Components/Sections/HeroSections';
import FeaturesSection from '../../Components/Sections/FeaturesSection';
import TestimonialsSection from '../../Components/Sections/TestimonialsSection';
import DemoSection from '../../Components/Sections/DemoSection';
import ProductFeaturesSection from '../../Components/Sections/ProductFeaturesSection';
import PackagesSection from '../../Components/Sections/PackagesSection';
import SupportSection from '../../Components/Sections/SupportSection';
import TeamSection from '../../Components/Sections/TeamSection';
import VisitSection from '../../Components/Sections/VisitSection';
import FAQSection from '../../Components/Sections/FAQSection';
import ReviewsSection from '../../Components/Sections/ReviewsSection';
import StickyPricingFooter from '../../Components/Sections/StickyPricingFooter';
import { useLeadData } from '../../Utils/LeadContext';
import { getImagePath, checkLPData, isFlashOfferOn } from '../../Utils/Utilities';
import { useSearchParams, useLocation } from 'react-router-dom';
import apiService from '../../Utils/APIService';
import { useBrand } from '../../Utils/BrandContext';
import ContactSection from '../../Components/Sections/ContactSection';


const GQik = () => {
  const { leadData, loading } = useLeadData();
  const { brand: activeBrand } = useBrand();
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const currentPage = pathname.replace('/', '').toUpperCase() || 'GQIK';

  const rfdAvl = false;
  const flashOfferOn = isFlashOfferOn();
  const isMidnight = [0, 1, 23].includes(new Date().getHours());


  const brandLogo = activeBrand === 'bz' ? getImagePath("/Images/Biziverse.png") : getImagePath("/Images/QikERP.png");
  const isFromGQik = true; // Flag to indicate this is GQik page
  const isMobile = typeof window !== 'undefined' && /Mobi|Android/i.test(navigator.userAgent);

  const sendSensor = (actionID, actionTxt = '', sensorTxt = '') => {
    const finalTxt = sensorTxt || actionTxt;
    const allDataRaw = localStorage.getItem('allData');
    let leadPIN = '';
    let mobile = '';
    if (allDataRaw) {
      const allData = JSON.parse(allDataRaw);
      const leadInfo = allData.info ? JSON.parse(allData.info) : [];
      mobile = allData.mobile || '';
      leadPIN = leadInfo[0]?.LeadO || '';
    }
    apiService.sendCallSensorReq(actionID, finalTxt, { leadPIN, mobile, device: isMobile ? 'M' : 'D' });
  };

  useEffect(() => {
    if (!checkLPData('GQIK', searchParams)) return;

    const scrollParam = searchParams.get('scroll');

    if (scrollParam !== 'pricing') {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }

    if (scrollParam === 'pricing') {
      setTimeout(() => {
        const packagesSection = document.getElementById('simplePricing');
        if (packagesSection) {
          window.scrollTo({
            top: packagesSection.offsetTop - 60,
            behavior: 'smooth'
          });
        }
      }, 200);
    }
  }, [searchParams]);
  const handleLoginClick = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      const navbarHeight = 70;
      const targetPosition = heroSection.offsetTop - navbarHeight;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      // Focus on mobile input after scroll
      setTimeout(() => {
        const mobileInput = document.getElementById('mobile');
        if (mobileInput) {
          mobileInput.focus();
          // Add highlight effect
          const wrapper = mobileInput.parentElement;
          if (wrapper) {
            wrapper.style.borderColor = '#e88421';
            wrapper.style.boxShadow = '0 0 10px rgba(232, 132, 33, 0.5)';

            setTimeout(() => {
              wrapper.style.borderColor = '';
              wrapper.style.boxShadow = '';
            }, 2000);
          }
        }
      }, 600);
    }
  };

  const handleGetStarted = (mobileNumber) => {
    console.log('Get Started with:', mobileNumber);
    // Add your get started logic here
    // e.g., navigate to signup page: window.location.href = `/Join01.html?i=${mobileNumber}&x=Desktop_QikERP`;
  };

  const handleLogin = (mobileNumber) => {
    console.log('Login with:', mobileNumber);
    // Add your login logic here
    // e.g., show login modal or make API call
  };
  const handleScrollToPricing = () => {
    const packagesSection = document.getElementById('simplePricing');
    if (packagesSection) {
      window.scrollTo({
        top: packagesSection.offsetTop - 70,
        behavior: 'smooth'
      });
    }
  };

  const handleBuyNow = (editionId = 34) => {
    const finalEdnId = (editionId && typeof editionId !== 'object') ? editionId : 34;
    const allDataRaw = localStorage.getItem('allData');

    if (allDataRaw) {
      const allData = JSON.parse(allDataRaw);
      const leadInfo = allData.info ? JSON.parse(allData.info) : [];

      localStorage.setItem("selEdn", finalEdnId);
      localStorage.setItem("selPrd", "YY");
      localStorage.removeItem("cpn");
      localStorage.setItem("guidePG", window.location.pathname.substring(1));

      const cioData = [{ 'i': allData.mobile, 'o': leadInfo[0]?.LeadO }];
      localStorage.setItem('cio', JSON.stringify(cioData));

      window.location.href = "/Html/External/BZPay.html";
    } else {
      handleScrollToPricing();
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar
        logo={brandLogo}
        onLoginClick={handleLoginClick}
        isFromGQik={isFromGQik}
        onBuyNowClick={() => {
          handleScrollToPricing();
          sendSensor(105, 'Buy Now Clicked');
        }}
      />

      <main>
        {/* Hero Section */}
        <HeroSection
          onGetStarted={handleGetStarted}
          onLogin={handleLogin}
          isFromGQik={isFromGQik}
          onBuyNow={() => { sendSensor(105, 'Buy Now Clicked'); }}
          logo={brandLogo}
          rfdAvl={rfdAvl}
          flashOfferOn={flashOfferOn}
          isMidnight={isMidnight}
        />

        {/* Features Section */}
        <FeaturesSection
          onBuyNow={handleScrollToPricing}
          pricing={{ silver: 2999, gold: 4999 }}
          rfdAvl={rfdAvl}
          onBuyNowClick={() => sendSensor(105, 'Buy Now Clicked')}
          flashOfferOn={flashOfferOn}
          pageName={currentPage}
        />

        {/* Testimonials Section */}
        {/* <TestimonialsSection /> */}

        {/* Demo Section */}
        <DemoSection onDemoView={() => sendSensor(4, 'Reached Demo')} onDemoOpen={() => sendSensor(4, 'Demo')} onDemoScreens={() => sendSensor(7, 'DemoScreens')} />

        {/* Product Features Section */}
        <ProductFeaturesSection onBuyNow={handleScrollToPricing} onFeatureClick={(featureName) => sendSensor(104, featureName)} />

        {/* Packages/Pricing Section */}
        <PackagesSection
          onBuyNow={handleBuyNow}
          pageName={currentPage}
          showCoupons={true}
          onCouponView={(editionName) => sendSensor(109, `View Coupons (${editionName})`)}
          onPackageClick={(pkgId) => sendSensor(pkgId)}
          onPackageView={() => sendSensor(4, 'Package View')}
          onGetOffer={() => sendSensor(4, 'Get Offer Clicked')}
        />

        <TestimonialsSection brandLogo={brandLogo} />

        {/* Support Section */}
        <SupportSection />

        {/* Team/About Section */}
        <TeamSection onTeamView={() => sendSensor(11, 'Team')} />

        {/* Visit Section */}
        <VisitSection />

        {/* FAQ Section */}
        <FAQSection
          onFAQToggle={(question) => sendSensor(106, `Guide-FAQ (${question})`)}
          onBuyNow={handleBuyNow}
        />
        <ContactSection className="" isFromLP={true} />

      </main>

      <Footer />
      <StickyPricingFooter
        pageName={currentPage}
        onBuyNow={handleBuyNow}
        onGetOffer={() => sendSensor(4, 'Flash Footer Clicked')}
      />
    </div>
  );
};

export default GQik;